import axio from "axios";

const apiKey = "3668fcf30ca24833abb1bf05d3c57809";
const baseUrl = "https://api.ipgeolocation.io/ipgeo";

export const getLocationInfo = ip =>
	new Promise((resolve, reject) => {
		axio({
			method: "GET",
			params: {
				apiKey,
				ip
			},
			url: baseUrl
		})
			.then(cb => {
				if (cb.status === 200) {
					resolve(cb.data);
				} else {
					reject(cb.statusText);
				}
			})
			.catch(err => reject(err.message));
	});
